import { InputHTMLAttributes } from 'react'

interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  /** What is wrong with the value; shown under the field */
  error?: string | null
}

const FormInput = ({
  label,
  id,
  className,
  error,
  ...props
}: FormInputProps & { className?: string }) => {
  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={id}
        className="text-xs font-medium text-muted-foreground uppercase tracking-wide"
        style={{ fontWeight: 500 }}
      >
        {label}
      </label>
      <input
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={error && id ? `${id}-error` : undefined}
        className={`${error ? 'border-red-500/60 ' : ''}w-full px-4 py-3 rounded-xl border border-border bg-muted text-foreground text-sm
                   placeholder:text-muted-foreground focus:outline-hidden focus:ring-2 focus:ring-[#C0FD72]/50 focus:border-[#C0FD72]
                   transition-all duration-200 ${className || ''}`}
        {...props}
      />
      {error && (
        <p id={id ? `${id}-error` : undefined} className="text-xs text-red-500">
          {error}
        </p>
      )}
    </div>
  )
}

export default FormInput
